import { Navigate, Outlet } from 'react-router-dom';
import { useUser } from '@myosh/myosh-login';

export const PrivateRoute = () => {
  const { state } = useUser();
  const isAuthenticated = state.auth;

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  return <Outlet />;
};
